var Genders = /*#__PURE__*/function (Genders) {
  Genders["FEMALE"] = "female";
  Genders["MALE"] = "male";
  Genders["UNDETERMINED"] = "undetermined";
  return Genders;
}(Genders || {});
export default Genders;